import React from 'react';

const ElementIcon = ({ name, className = '', ...props }) => {
  return <i className={`el-icon-${name} ${className}`} {...props}></i>;
}

export default ElementIcon;
